"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f104 = void 0;
exports.f104 = {
    "hijazi": [
        81
    ],
    "hejazi arabic": [
        81
    ],
    "hejazi": [
        81
    ],
    "hijazi arabic": [
        81
    ],
    "hadari": [
        82
    ],
    "haeke": [
        121
    ],
    "haeake": [
        121
    ],
    "harème": [
        123
    ],
    "hayeren žesteri lezow": [
        124
    ],
    "hayeren": [
        124
    ],
    "hžl": [
        124
    ],
    "heneng": [
        239,
        154,
        348
    ],
    "hatang-kayey": [
        171
    ],
    "hulani": [
        204
    ],
    "hula’ula": [
        204
    ],
    "hwè": [
        221
    ],
    "houaïlou": [
        222
    ],
    "halakwulup": [
        258
    ],
    "halak": [
        266
    ],
    "harak": [
        266
    ],
    "harlak": [
        266
    ],
    "hrlak": [
        266
    ],
    "hamer-banna": [
        289,
        290
    ],
    "huaʼa": [
        302
    ],
    "háte": [
        302
    ],
    "harakmbut": [
        302
    ],
    "haté": [
        302
    ],
    "hua’a": [
        302
    ],
    "high aragonese": [
        314
    ],
    "high": [
        2692,
        2731,
        314,
        4002,
        4300,
        4301,
        5049
    ],
    "haraneu": [
        319
    ],
    "humbra": [
        334
    ],
    "ha’us": [
        341
    ],
    "hikariya": [
        378
    ],
    "hoyero": [
        378
    ],
    "huilliche": [
        3078,
        446
    ],
    "hinónoʼeitíít": [
        448
    ],
    "hohe": [
        461
    ],
    "haitian sign language": [
        463,
        464
    ],
    "haitian": [
        3064,
        3096,
        463,
        464
    ],
    "haïtienne": [
        463,
        464
    ],
    "huao": [
        512
    ],
    "huao auca": [
        512
    ],
    "huaorani": [
        512
    ],
    "heiyoho": [
        518
    ],
    "heyo": [
        518
    ],
    "hunter river – lake macquarie": [
        553
    ],
    "hunter": [
        553
    ],
    "haragure": [
        571
    ],
    "hadrami": [
        8476,
        579
    ],
    "hadhrami arabic": [
        579
    ],
    "hadhrami": [
        579
    ],
    "hadrami arabic": [
        579
    ],
    "hadromi": [
        579
    ],
    "han phula": [
        598
    ],
    "han": [
        2882,
        598,
        2997,
        2998,
        8923,
        8924,
        8925,
        8926
    ],
    "hei phula": [
        598,
        8819,
        8883
    ],
    "hei": [
        598,
        933,
        934,
        935,
        2986,
        2989,
        2991,
        4646,
        8753,
        8761,
        8819,
        8883,
        8887,
        8891,
        8916,
        8949,
        8950
    ],
    "hua phula": [
        598,
        8753,
        8792,
        8885
    ],
    "hua": [
        598,
        1595,
        2977,
        8753,
        8792,
        8885,
        8888,
        2063,
        2523,
        2524,
        2525,
        2973,
        2974,
        2975,
        6801,
        9047,
        9048
    ],
    "hua yi": [
        598
    ],
    "highland": [
        608,
        1440,
        1528,
        1669,
        3708,
        5987,
        6255,
        6354,
        6399,
        6401,
        6419,
        6420,
        6439,
        6444,
        7653,
        1454,
        3213,
        3283,
        3284,
        3285,
        3286,
        3287,
        3481,
        4594,
        4804,
        5049,
        5745,
        7880,
        8502,
        4571
    ],
    "highland puebla nahuatl": [
        608
    ],
    "hualo": [
        641
    ],
    "hualuo": [
        641
    ],
    "huazu": [
        641
    ],
    "hohumono": [
        678
    ],
    "humono": [
        678
    ],
    "harja": [
        706
    ],
    "hounar": [
        732
    ],
    "huner": [
        732
    ],
    "hibena": [
        740
    ],
    "haryanvi": [
        781
    ],
    "hariani": [
        781
    ],
    "hariyani": [
        781
    ],
    "haryani": [
        781
    ],
    "hill": [
        5049,
        1889,
        2069,
        2095,
        3300,
        4832,
        5058,
        7714,
        7715,
        793
    ],
    "hawlh": [
        795,
        1545
    ],
    "hadem": [
        853
    ],
    "hindi": [
        2933,
        2934,
        2935,
        2936,
        2940,
        2941,
        2916,
        868,
        1936,
        1937,
        1938,
        3013
    ],
    "hkawa": [
        928,
        929,
        930,
        931
    ],
    "hei dai": [
        933,
        934,
        935
    ],
    "herzegovina": [
        1114,
        1115,
        3043,
        7089,
        7093
    ],
    "hunza": [
        1125,
        1126
    ],
    "hadera": [
        1129
    ],
    "hanera": [
        1129,
        6256
    ],
    "hanera oka": [
        1129
    ],
    "hatumeten": [
        1168
    ],
    "hm nai": [
        1235
    ],
    "hm": [
        1235
    ],
    "huve": [
        1240
    ],
    "huviya": [
        1240
    ],
    "hain": [
        1320
    ],
    "hainyaxo bozo": [
        1320
    ],
    "hainyaxo": [
        1320
    ],
    "hanyaxo": [
        1320
    ],
    "hn": [
        1329,
        2273,
        2918,
        3364,
        4278,
        6041
    ],
    "honduras": [
        2918,
        1329,
        2273,
        3364,
        4278,
        6041
    ],
    "hasí:nay": [
        1331
    ],
    "hatsinai": [
        1331
    ],
    "hianacoto": [
        1354
    ],
    "hianacoto-umaua": [
        1354
    ],
    "hianakoto": [
        1354
    ],
    "huaque": [
        1354
    ],
    "hagueti": [
        1364
    ],
    "hãtxa kuī": [
        1365
    ],
    "hãtxa": [
        1365
    ],
    "hantxa kuin": [
        1365
    ],
    "hantxa": [
        1365
    ],
    "huni kui": [
        1365
    ],
    "huni": [
        1365
    ],
    "huni kuin": [
        1365
    ],
    "haal": [
        1377
    ],
    "hokchiu": [
        1398,
        1399,
        1400
    ],
    "hnise": [
        1414
    ],
    "halam": [
        1428,
        1429,
        1430,
        1431,
        1432,
        7714,
        7715
    ],
    "halam chin": [
        1428,
        1429,
        1430,
        1431,
        1432
    ],
    "hallam": [
        1428,
        1429,
        1430,
        1431,
        1432
    ],
    "hallam chin": [
        1428,
        1429,
        1430,
        1431,
        1432
    ],
    "highland chontal": [
        1440
    ],
    "highland oaxaca chontal": [
        1440
    ],
    "highland chinantec": [
        1454
    ],
    "harijan": [
        1469
    ],
    "ha-tiri": [
        1474
    ],
    "hamea": [
        1474
    ],
    "haméa": [
        1474
    ],
    "hma": [
        1481
    ],
    "hr": [
        1501,
        1502,
        1647,
        1894,
        3042,
        3044,
        3258,
        6626
    ],
    "hio bei": [
        1519
    ],
    "hio": [
        1519,
        1639
    ],
    "hle-tu": [
        1519
    ],
    "huamelula chontal": [
        1524
    ],
    "huamelula": [
        1524
    ],
    "huamelulteco": [
        1524
    ],
    "hakha": [
        1545
    ],
    "haka": [
        1545,
        1892
    ],
    "haka chin": [
        1545
    ],
    "hakha chin": [
        1545
    ],
    "hakha lai": [
        1545
    ],
    "haqbaylit̠": [
        1556
    ],
    "huallaga": [
        6397,
        1563
    ],
    "heng": [
        1593
    ],
    "henghua": [
        1593
    ],
    "hing": [
        1593
    ],
    "hinghua": [
        1593
    ],
    "hsien": [
        1593
    ],
    "hsienyu": [
        1593
    ],
    "hsing": [
        1593
    ],
    "hsinghua": [
        1593
    ],
    "hmongic": [
        1595
    ],
    "hua miao": [
        1595,
        2973,
        2974,
        2975
    ],
    "hyow": [
        1636,
        1637
    ],
    "hzj": [
        1647
    ],
    "hrvatski znakovni jezik": [
        1647
    ],
    "hrvatski": [
        3042,
        3043,
        1647,
        3044
    ],
    "hmyo": [
        1651
    ],
    "hanis": [
        1655
    ],
    "hai-dim": [
        1658,
        1659
    ],
    "hehenawa": [
        1681
    ],
    "hipnwa": [
        1681
    ],
    "hiwi": [
        1685,
        2809,
        3842
    ],
    "huayao dai": [
        1694
    ],
    "huayao": [
        1694
    ],
    "huayaodai": [
        1694
    ],
    "hongjin": [
        7519,
        1694
    ],
    "huizhou": [
        1713,
        1714
    ],
    "hui": [
        1713,
        1714,
        3086,
        9020,
        9021,
        9022,
        9030,
        9040,
        4120
    ],
    "huizhou chinese": [
        1713,
        1714
    ],
    "ham": [
        1724,
        3306
    ],
    "horn": [
        1739
    ],
    "hochdeutsch": [
        1786
    ],
    "huluníixsuwaakan": [
        1802
    ],
    "hude": [
        1819
    ],
    "himba": [
        1836,
        3108,
        6714
    ],
    "hills kachari": [
        1861,
        1862
    ],
    "hills": [
        1861,
        1862
    ],
    "hadjer": [
        1870
    ],
    "hill dusun": [
        1889
    ],
    "huizu": [
        1917
    ],
    "hindi dogri": [
        1936,
        1937,
        1938
    ],
    "hopupo bro": [
        2012
    ],
    "hopupo": [
        2012
    ],
    "hileman": [
        2043
    ],
    "hloka": [
        2044
    ],
    "hwen": [
        3111,
        2063
    ],
    "hill mada": [
        2069
    ],
    "hor": [
        2083,
        2251,
        3033,
        6676,
        6677,
        6678,
        6679,
        6680
    ],
    "hretsʹkyy": [
        2090,
        2091,
        2093
    ],
    "hugeirat": [
        2095
    ],
    "hagarat": [
        2095
    ],
    "hill nubian": [
        2095
    ],
    "hk": [
        2161,
        2963,
        8923,
        8924,
        9025,
        9027
    ],
    "hong kong": [
        2161,
        2963,
        8923,
        8924,
        9025,
        9027
    ],
    "hong": [
        2963,
        8923,
        8924,
        8925,
        8926,
        4249,
        2161,
        9025,
        9027
    ],
    "helena": [
        2204
    ],
    "horpa": [
        2251
    ],
    "huo’er": [
        2251
    ],
    "hórsók": [
        2251
    ],
    "haya": [
        2909,
        2254
    ],
    "huarayo": [
        2286
    ],
    "huelel": [
        2296
    ],
    "haalpulaar": [
        2352,
        2365
    ],
    "himbul": [
        2402
    ],
    "himli": [
        2402
    ],
    "hova": [
        2402,
        4736,
        4738
    ],
    "ht": [
        2440,
        3064,
        3096
    ],
    "haiti": [
        2440,
        3064,
        3096
    ],
    "hay": [
        2479,
        2480,
        3710
    ],
    "hausa states fulfulde": [
        2497,
        2498
    ],
    "hausa": [
        2874,
        2875,
        2876,
        2877,
        2878,
        2879,
        2880,
        2881,
        3060,
        2497,
        2498
    ],
    "houla": [
        2562
    ],
    "h-alba": [
        2573
    ],
    "hallari": [
        2575,
        2576
    ],
    "hollar gadbas": [
        2575,
        2576
    ],
    "hollar": [
        2575,
        2576
    ],
    "hutterisch": [
        2603
    ],
    "hutterite": [
        2603
    ],
    "hutterian german": [
        2603
    ],
    "hutterian": [
        2603
    ],
    "hutterite german": [
        2603
    ],
    "hiberno-scottish gaelic": [
        2628
    ],
    "hiberno-scottish": [
        2628
    ],
    "highlands": [
        2647
    ],
    "hinukh": [
        2648
    ],
    "hinuq": [
        2648
    ],
    "hinux": [
        2648
    ],
    "hagei": [
        2650
    ],
    "hagei gelao": [
        2650
    ],
    "hakei": [
        2650
    ],
    "hakhi": [
        2650
    ],
    "hoki gelao": [
        2650
    ],
    "hoki": [
        2650
    ],
    "hazelton": [
        2653
    ],
    "hindki": [
        2665,
        2666
    ],
    "heche": [
        2677
    ],
    "hezhe": [
        2677
    ],
    "hezhen": [
        2677
    ],
    "hamej": [
        2687
    ],
    "holontalo": [
        2745
    ],
    "hulondalo": [
        2745
    ],
    "hulontalo": [
        2745
    ],
    "hulonthalo": [
        2745
    ],
    "hivi": [
        2809
    ],
    "huachi": [
        2868
    ],
    "habe": [
        2874,
        2875,
        2876,
        4203
    ],
    "haoussa": [
        2874,
        2875,
        2876,
        2877,
        2880
    ],
    "hausawa": [
        2874,
        2875,
        2876,
        2880
    ],
    "haussa": [
        2874,
        2875,
        2876,
        2880
    ],
    "hawsa": [
        2874,
        2875,
        2876,
        2877
    ],
    "han-kutchin": [
        2882
    ],
    "hän": [
        2882
    ],
    "hwëch’in": [
        2882
    ],
    "hanoi sign language": [
        2883
    ],
    "hanoi": [
        2883
    ],
    "hnsl": [
        2883
    ],
    "ha noi sign language": [
        2883
    ],
    "ha": [
        2901,
        4324,
        2883,
        3004,
        8923,
        8924,
        8925,
        8926,
        4313
    ],
    "hawramani": [
        2884
    ],
    "hawrami": [
        2884
    ],
    "hewrami": [
        2884
    ],
    "hourami": [
        2884
    ],
    "howrami": [
        2884
    ],
    "hatam": [
        2885
    ],
    "hattam": [
        2885
    ],
    "haiphong sign language": [
        2887
    ],
    "haiphong": [
        2887
    ],
    "hpsl": [
        2887
    ],
    "hai phong sign language": [
        2887
    ],
    "hai": [
        2887,
        4378,
        8923,
        8924,
        8925,
        8926
    ],
    "hanga": [
        2888,
        8319,
        4550
    ],
    "haŋa": [
        2888
    ],
    "hahon": [
        2889
    ],
    "hanon": [
        2889
    ],
    "haida": [
        2890,
        2908
    ],
    "haida, northern": [
        2890
    ],
    "hajong": [
        2891,
        2892
    ],
    "haijong": [
        2891,
        2892
    ],
    "hajang": [
        2891,
        2892
    ],
    "hajong bhasa": [
        2891,
        2892
    ],
    "hazong": [
        2891,
        2892
    ],
    "hakka": [
        2893,
        2894,
        2895
    ],
    "hakka chinese": [
        2893,
        2894,
        2895
    ],
    "hokka": [
        2893,
        2894,
        2895
    ],
    "halang": [
        2896,
        2966
    ],
    "hewa": [
        2897
    ],
    "hangaza": [
        2898
    ],
    "hakö": [
        2899
    ],
    "haku": [
        2899
    ],
    "hupla": [
        2900
    ],
    "harari": [
        2902,
        2903,
        2904
    ],
    "haisla": [
        2905
    ],
    "haishilla": [
        2905
    ],
    "havu": [
        2906,
        3099
    ],
    "haavu": [
        2906
    ],
    "hawaiian": [
        2907,
        3041,
        3102
    ],
    "hawaiʻi": [
        2907
    ],
    "hawai’i": [
        3041,
        3102,
        2907
    ],
    "haida, southern": [
        2908
    ],
    "hazaragi": [
        2910
    ],
    "hazara": [
        2910,
        3012
    ],
    "hazaraghi": [
        2910
    ],
    "hezareh": [
        2910
    ],
    "hezare’i": [
        2910
    ],
    "hamba": [
        2911,
        5495,
        6640
    ],
    "huba": [
        2912
    ],
    "heiban": [
        2913
    ],
    "hebrew, ancient": [
        2914
    ],
    "hebrew": [
        2914,
        2921,
        2922,
        6976,
        6977,
        3341,
        3342,
        3343,
        6975
    ],
    "habun": [
        2915
    ],
    "habu": [
        2915
    ],
    "huichol": [
        2917
    ],
    "honduran sign language": [
        2918
    ],
    "honduran": [
        2918
    ],
    "honduras sign language": [
        2918
    ],
    "hondureñas": [
        2918
    ],
    "hadiyya": [
        2919,
        2920
    ],
    "herdé": [
        2923
    ],
    "he’dé": [
        2923
    ],
    "helong": [
        2924
    ],
    "helon": [
        2924
    ],
    "hehe": [
        2925
    ],
    "heiltsuk": [
        2926
    ],
    "hailhzaqvla": [
        2926
    ],
    "hemba": [
        2927
    ],
    "hai|ǁom": [
        2928
    ],
    "haikom": [
        2928
    ],
    "haikum": [
        2928
    ],
    "haiǁom": [
        2928
    ],
    "heikom": [
        2928
    ],
    "heikom bushman": [
        2928
    ],
    "heikum": [
        2928
    ],
    "hei|ǁom": [
        2928
    ],
    "haigwai": [
        2929
    ],
    "hoia hoia": [
        2930
    ],
    "hoia": [
        2930
    ],
    "hoiahoia": [
        2930,
        2932
    ],
    "hoyahoya": [
        2932,
        2930
    ],
    "her": [
        2931
    ],
    "hoya hoya": [
        2932
    ],
    "hoya": [
        2932
    ],
    "hindi-urdu": [
        2933,
        2934,
        2935,
        2936
    ],
    "hindustani": [
        3013,
        2933,
        2934,
        2935,
        2936,
        2940,
        2941
    ],
    "hibito": [
        2938
    ],
    "hivito": [
        2938
    ],
    "hidatsa": [
        2939
    ],
    "hinatsa": [
        2939
    ],
    "hiraca": [
        2939
    ],
    "hindi, fiji": [
        2940,
        2941
    ],
    "hiji": [
        2942
    ],
    "hinihon": [
        2943
    ],
    "hinduri": [
        2944,
        2945
    ],
    "handuri": [
        2944,
        2945
    ],
    "hijuk": [
        2946
    ],
    "hila-kaitetu": [
        2947
    ],
    "hiligaynon": [
        2948,
        2949
    ],
    "hiligainon": [
        2948,
        2949
    ],
    "haitshuari": [
        2950
    ],
    "haitshuwau": [
        2950
    ],
    "hiechware": [
        2950
    ],
    "hietshware": [
        2950
    ],
    "hiochuwau": [
        2950
    ],
    "hiotshuwau": [
        2950
    ],
    "himarimã": [
        2951
    ],
    "hi-merima": [
        2951
    ],
    "hittite": [
        2952,
        3069,
        5854
    ],
    "hiw": [
        2953
    ],
    "hiu": [
        2953
    ],
    "hixkaryána": [
        2954
    ],
    "hichkaryana": [
        2954
    ],
    "hishkariana": [
        2954
    ],
    "hishkaryana": [
        2954
    ],
    "hixkariana": [
        2954
    ],
    "hyxkaryana": [
        2954
    ],
    "haji": [
        2955
    ],
    "hunde": [
        2957
    ],
    "hunjara-kaina ke": [
        2961
    ],
    "hunjara-kaina": [
        2961
    ],
    "hong kong sign language": [
        2963
    ],
    "hksl": [
        2963
    ],
    "heung kong sau yue": [
        2963
    ],
    "heung": [
        2963
    ],
    "halia": [
        2964
    ],
    "halbi": [
        2965
    ],
    "halabi": [
        2965
    ],
    "halba": [
        2965
    ],
    "halvas": [
        2965
    ],
    "halvi": [
        2965
    ],
    "holva": [
        2965
    ],
    "halang doan": [
        2966
    ],
    "halang duan": [
        2966
    ],
    "hlersu": [
        2967
    ],
    "hieroglyphic luwian": [
        2969
    ],
    "hieroglyphic": [
        2969
    ],
    "hsiung": [
        2970,
        2972
    ],
    "hunan miao": [
        2970,
        2972,
        2977
    ],
    "hunan": [
        2970,
        2972,
        2977,
        3061,
        3062,
        4918
    ],
    "hmong": [
        2977,
        2985,
        2986,
        2987,
        2994,
        3005,
        3006,
        3007,
        3008,
        3009,
        5197,
        5198,
        5199,
        5200,
        5201,
        2997,
        2998,
        3050,
        2970,
        2972,
        2976,
        2978,
        2979,
        2980,
        2983,
        2984,
        2988,
        2995,
        2996,
        3080
    ],
    "humburi": [
        2971
    ],
    "hombori songhay": [
        2971
    ],
    "hombori": [
        2971
    ],
    "humburi senni songhay": [
        2971
    ],
    "huishui": [
        2972,
        2976,
        2979,
        2980
    ],
    "hmo": [
        2972,
        3050
    ],
    "hmaob": [
        2973,
        2974,
        2975
    ],
    "hwa miao": [
        2973,
        2974,
        2975
    ],
    "hwa": [
        2973,
        2974,
        2975,
        6801
    ],
    "hmong don": [
        2977
    ],
    "hua binh": [
        2977
    ],
    "hmu": [
        2991,
        2986,
        2989
    ],
    "heh miao": [
        2986
    ],
    "heh": [
        2986
    ],
    "hei miao": [
        2986,
        2989,
        2991
    ],
    "has": [
        2986
    ],
    "hmar": [
        2990
    ],
    "hamar": [
        2990
    ],
    "hmari": [
        2990
    ],
    "hamtai": [
        2992
    ],
    "hamday": [
        2992
    ],
    "hamap": [
        2993
    ],
    "hmong dô": [
        2994
    ],
    "head": [
        2997,
        2998
    ],
    "han miao": [
        2997,
        2998
    ],
    "hmong nzi": [
        2997,
        2998
    ],
    "hmong sa": [
        2997,
        2998
    ],
    "hmong shua": [
        2997,
        2998
    ],
    "hmong sua": [
        2997,
        2998
    ],
    "hmongb shuat": [
        2997,
        2998
    ],
    "hmongb": [
        2997,
        2998,
        3005,
        3006,
        3007,
        3008,
        3009,
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "hina": [
        2999
    ],
    "hindko, southern": [
        3000
    ],
    "hindko": [
        3000,
        3012
    ],
    "hungu": [
        3002
    ],
    "handa-khwe": [
        3003
    ],
    "handakwe-dam": [
        3003
    ],
    "handá": [
        3003
    ],
    "handádam": [
        3003
    ],
    "hani": [
        3004
    ],
    "ha nhi": [
        3004
    ],
    "hanhi": [
        3004
    ],
    "hani proper": [
        3004
    ],
    "haw": [
        3004
    ],
    "hayi": [
        3004
    ],
    "hànhì": [
        3004
    ],
    "hmong njua": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "hmong leng": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "hmong nzhua": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "hmongb nzhuab": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "hmoob leeg": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "hmoob": [
        3005,
        3006,
        3007,
        3008,
        3009,
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "hanunoo": [
        3010,
        3011
    ],
    "hanonoo": [
        3010,
        3011
    ],
    "hanunoo-mangyan": [
        3010,
        3011
    ],
    "hindko, northern": [
        3012
    ],
    "hazara hindko": [
        3012
    ],
    "hindustani, sarnami": [
        3013
    ],
    "hiendoestaanie": [
        3013
    ],
    "hindoestani": [
        3013
    ],
    "hung": [
        3014,
        5755,
        6121
    ],
    "hiri": [
        3015,
        3016
    ],
    "hiri motu": [
        3015,
        3016
    ],
    "hoava": [
        3017
    ],
    "hop": [
        3018
    ],
    "ho": [
        3019,
        3020,
        3021,
        3022,
        3023,
        3034,
        3037,
        6859,
        7654,
        8740,
        3886,
        5077
    ],
    "ho haram": [
        3019,
        3020,
        3021,
        3022,
        3023
    ],
    "haram": [
        3019,
        3020,
        3021,
        3022,
        3023
    ],
    "ho jagar": [
        3019,
        3020,
        3021,
        3022,
        3023
    ],
    "ho kaji": [
        3019,
        3020,
        3021,
        3022,
        3023
    ],
    "holma": [
        3024
    ],
    "holmaci": [
        3024
    ],
    "horom": [
        3025
    ],
    "hobyót": [
        3026
    ],
    "hewbyót": [
        3026
    ],
    "hobi": [
        3026
    ],
    "holikachuk": [
        3027
    ],
    "haroti": [
        3028
    ],
    "hadauti": [
        3028
    ],
    "hadothi": [
        3028
    ],
    "hadoti": [
        3028
    ],
    "hara": [
        3028
    ],
    "harauti": [
        3028
    ],
    "holu": [
        3029,
        3038
    ],
    "holo": [
        5053,
        3029
    ],
    "hongu": [
        3029
    ],
    "homa": [
        3030
    ],
    "holoholo": [
        3031
    ],
    "horohoro": [
        3031
    ],
    "hopi": [
        3032
    ],
    "hopílavayi": [
        3032
    ],
    "horo": [
        3033,
        7976,
        7977,
        7978,
        7979,
        8459
    ],
    "ho chi minh city sign language": [
        3034
    ],
    "hcmcsl": [
        3034
    ],
    "hote": [
        3035
    ],
    "hotec": [
        3035
    ],
    "ho’tei": [
        3035
    ],
    "hovongan": [
        3036
    ],
    "hobongan": [
        3036
    ],
    "honi": [
        3037
    ],
    "hao-bai": [
        3037
    ],
    "haoni": [
        3037
    ],
    "holiya": [
        3038
    ],
    "holar": [
        3038
    ],
    "holari": [
        3038
    ],
    "hole": [
        3038
    ],
    "holian": [
        3038
    ],
    "hozo": [
        3039
    ],
    "hpon": [
        3040
    ],
    "hpun": [
        3040
    ],
    "hpön": [
        3040
    ],
    "hawaii sign language": [
        3041
    ],
    "hawaii": [
        3041,
        3102
    ],
    "hps": [
        3041
    ],
    "hsl": [
        3041,
        3060
    ],
    "hawai'i pidgin sign language": [
        3041
    ],
    "hawai'i sign language (hsl)": [
        3041
    ],
    "hawaiian sign language": [
        3041
    ],
    "hawai’i pidgin sign language": [
        3041
    ],
    "hrangkhol": [
        3045
    ],
    "hrangkol": [
        3045
    ],
    "hre": [
        3047,
        3048
    ],
    "hrey": [
        3047,
        3048
    ],
    "hrê": [
        3047,
        3048
    ],
    "haruku": [
        3049
    ],
    "horned": [
        3050
    ],
    "hmong khua shua ndrang": [
        3050
    ],
    "hmong ndong": [
        3050
    ],
    "hmong ndou": [
        3050
    ],
    "hmong sou": [
        3050
    ],
    "horned miao": [
        3050
    ],
    "haroi": [
        3051
    ],
    "hoi": [
        3051,
        7762
    ],
    "hroi": [
        3051
    ],
    "hroy": [
        3051
    ],
    "hrway": [
        3051
    ],
    "hértevin": [
        3053
    ],
    "hartevan": [
        3053
    ],
    "hertevince": [
        3053
    ],
    "hruso": [
        3054
    ],
    "hrusso": [
        3054
    ],
    "hunsrik": [
        3056
    ],
    "hunsrick": [
        3056
    ],
    "hunsrickisch": [
        3056
    ],
    "hunsriker": [
        3056
    ],
    "hunsriqueano": [
        3056
    ],
    "hunsriqueano riograndense": [
        3056
    ],
    "hunsrück": [
        3056
    ],
    "harzani": [
        3057
    ],
    "harzandi": [
        3057
    ],
    "hornjoserbšćina": [
        3058
    ],
    "haut sorabe": [
        3058
    ],
    "haut": [
        3058
    ],
    "hornjoserbsce": [
        3058
    ],
    "hornjoserbska rěč": [
        3058
    ],
    "hornjoserbska": [
        3058
    ],
    "hornjoserbski": [
        3058
    ],
    "hornoserbski": [
        3058
    ],
    "hungarian sign language": [
        3059
    ],
    "hungarian": [
        3059,
        3070,
        3071,
        5855,
        5856
    ],
    "hu": [
        3084,
        3059,
        3070,
        3071,
        4426,
        4427,
        5855,
        5856,
        8903
    ],
    "hungary": [
        3059,
        3070,
        3071,
        4426,
        4427,
        5855,
        5856,
        8903
    ],
    "hausa sign language": [
        3060
    ],
    "harshen bebaye na kasar hausa": [
        3060
    ],
    "harshen": [
        3060
    ],
    "hannu": [
        3060
    ],
    "hsiang": [
        3061,
        3062
    ],
    "hunanese": [
        3061,
        3062
    ],
    "harsusi": [
        3063
    ],
    "harsi ’aforit": [
        3063
    ],
    "harsi": [
        3063
    ],
    "hersyet": [
        3063
    ],
    "haitian creole": [
        3064
    ],
    "haïtien": [
        3064
    ],
    "hoti": [
        3065,
        8740
    ],
    "huitoto mɨnɨca": [
        3066
    ],
    "huitoto": [
        3066,
        3090,
        3093
    ],
    "huitoto meneca": [
        3066
    ],
    "hadza": [
        3067
    ],
    "hadzabi": [
        3067
    ],
    "hadzane": [
        3067
    ],
    "hadzape": [
        3067
    ],
    "hadzapi": [
        3067
    ],
    "hatsa": [
        3067
    ],
    "hitu": [
        3068
    ],
    "huambisa": [
        3072
    ],
    "huambiza": [
        3072
    ],
    "huaulu": [
        3074
    ],
    "huave, san francisco del mar": [
        3075
    ],
    "huave": [
        3075,
        3091,
        3097,
        3100
    ],
    "huave del este": [
        3075,
        3097
    ],
    "humene": [
        3076
    ],
    "huachipaeri": [
        3077
    ],
    "huachipaire": [
        3077
    ],
    "huilche": [
        3078
    ],
    "huiliche": [
        3078
    ],
    "huli": [
        3079
    ],
    "huli-hulidana": [
        3079
    ],
    "huri": [
        3079
    ],
    "hulung": [
        3081
    ],
    "hula": [
        3082
    ],
    "hungana": [
        3083
    ],
    "huana": [
        3083
    ],
    "hungaan": [
        3083
    ],
    "hungan": [
        3083
    ],
    "hunganna": [
        3083
    ],
    "hupa": [
        3085
    ],
    "hoopa": [
        3085
    ],
    "hoopa-chilula": [
        3085
    ],
    "hupa-chilula-whilkut": [
        3085
    ],
    "hainan cham": [
        3086
    ],
    "hainan": [
        3086,
        4824
    ],
    "huihui": [
        3086
    ],
    "halkomelem": [
        3087
    ],
    "halq’eméylem": [
        3087
    ],
    "holkomelem": [
        3087
    ],
    "hul’q’umi’num’": [
        3087
    ],
    "huastec": [
        3088
    ],
    "humla": [
        3089
    ],
    "humla tibetan": [
        3089
    ],
    "humli lama": [
        3089
    ],
    "humli": [
        3089
    ],
    "huitoto murai": [
        3090
    ],
    "huitoto murui": [
        3090
    ],
    "huave, san mateo del mar": [
        3091
    ],
    "huave del oeste": [
        3091,
        3100
    ],
    "hukumina": [
        3092
    ],
    "huitoto muinane": [
        3093
    ],
    "hulaulá": [
        3094
    ],
    "hunzib": [
        3095
    ],
    "hontl’os myts": [
        3095
    ],
    "hontl’os": [
        3095
    ],
    "haitian vodoun culture language": [
        3096
    ],
    "huave, san dionisio del mar": [
        3097
    ],
    "haveke": [
        3098
    ],
    "hawu": [
        3099
    ],
    "havunese": [
        3099
    ],
    "huave, santa maría del mar": [
        3100
    ],
    "hwane": [
        3101
    ],
    "hawaii pidgin": [
        3102
    ],
    "hce": [
        3102
    ],
    "hawai'i creole english": [
        3102
    ],
    "hawai'i pidgin": [
        3102
    ],
    "hawaiian creole": [
        3102
    ],
    "hawaiian creole english": [
        3102
    ],
    "hawaiian pidgin": [
        3102
    ],
    "hawai’i creole": [
        3102
    ],
    "hawai’i creole english": [
        3102
    ],
    "hwana": [
        3103
    ],
    "hona": [
        3103
    ],
    "hwona": [
        3103
    ],
    "haieren": [
        3104,
        3105
    ],
    "hya": [
        3106
    ],
    "hwate": [
        3106
    ],
    "herero": [
        3108
    ],
    "hwen iaai": [
        3111
    ],
    "hanalulo": [
        3153
    ],
    "holi": [
        3174
    ],
    "holli-djé": [
        3174
    ],
    "hɔlí": [
        3174
    ],
    "hahutan": [
        3203
    ],
    "hahutau": [
        3203
    ],
    "highland inga": [
        3213
    ],
    "higa": [
        3232
    ],
    "hamacore": [
        3233
    ],
    "héireann": [
        3250
    ],
    "holy see (vatican city state)": [
        3264,
        4185,
        5262
    ],
    "holy": [
        3264,
        4185,
        5262
    ],
    "highland yao": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "hill jarawa": [
        3300
    ],
    "hyam": [
        3306
    ],
    "hum": [
        3306
    ],
    "hyamhum": [
        3306
    ],
    "hut": [
        3311
    ],
    "het": [
        3311
    ],
    "hulu": [
        3313
    ],
    "hebrew tat": [
        3341,
        3342,
        3343
    ],
    "hora": [
        3413
    ],
    "hage aru": [
        3418
    ],
    "hage": [
        3418
    ],
    "haqaru": [
        3418
    ],
    "haqearu": [
        3418
    ],
    "haq’aru": [
        3418
    ],
    "hõne": [
        3430
    ],
    "hillary": [
        3431
    ],
    "hilleri": [
        3431
    ],
    "hupdë": [
        3437
    ],
    "hup": [
        3437
    ],
    "hupda": [
        3437
    ],
    "hupdah": [
        3437
    ],
    "hupdé": [
        3437
    ],
    "highland adyghe": [
        3481
    ],
    "hanty": [
        3506
    ],
    "hube": [
        3624
    ],
    "haria": [
        3660,
        3661
    ],
    "hkampti shan": [
        3663
    ],
    "hkampti": [
        3663
    ],
    "hkamti": [
        3663
    ],
    "humba": [
        3694,
        3695,
        8424
    ],
    "hakasi": [
        3705
    ],
    "hakass": [
        3705
    ],
    "highland konjo": [
        3708
    ],
    "hang": [
        3710,
        7672
    ],
    "hoc": [
        3710
    ],
    "hazake": [
        3728,
        3730,
        3731,
        3733
    ],
    "hāsàkè yǔyán": [
        3728,
        3730,
        3731,
        3733
    ],
    "hāsàkè": [
        3728,
        3730,
        3731,
        3733
    ],
    "hyabe": [
        3735
    ],
    "hkun": [
        3743
    ],
    "heì": [
        3780
    ],
    "havyaka": [
        3818,
        3819,
        3820
    ],
    "hibaradai": [
        3842
    ],
    "hangouyu": [
        3847,
        3848,
        3850
    ],
    "hanguohua": [
        3847,
        3848,
        3850
    ],
    "hanyu": [
        3847,
        3848,
        3850
    ],
    "hwaso": [
        3884
    ],
    "hwaye": [
        3884
    ],
    "hamtikanon": [
        3935
    ],
    "hamtiknon": [
        3935
    ],
    "hinaray-a": [
        3935
    ],
    "hiniraya": [
        3935
    ],
    "high katu": [
        4002
    ],
    "hutan": [
        4046
    ],
    "hanguk sueo": [
        4055
    ],
    "hanguk": [
        4055
    ],
    "hanguk suhwa eoneo": [
        4055
    ],
    "hair": [
        4058
    ],
    "haketia": [
        4189,
        4190,
        4191
    ],
    "hakitia": [
        4189,
        4190,
        4191
    ],
    "hapa": [
        4236
    ],
    "hema-nord": [
        4269
    ],
    "hoatana": [
        4299
    ],
    "high lugbara": [
        4300,
        4301
    ],
    "hur": [
        4315
    ],
    "hulimba ha": [
        4324
    ],
    "hulimba": [
        4324
    ],
    "hlai": [
        4326
    ],
    "ha’uwa": [
        4350
    ],
    "hermit": [
        4379
    ],
    "hano": [
        4405
    ],
    "havannah harbour": [
        4468
    ],
    "havannah": [
        4468
    ],
    "harbour": [
        4468,
        6933
    ],
    "hutuk na lopit": [
        4473
    ],
    "hutuk": [
        4473
    ],
    "hozaye": [
        4491
    ],
    "hudaye": [
        4491
    ],
    "hualngo": [
        4533,
        4534,
        4535
    ],
    "hyderabadi": [
        4538
    ],
    "htang ngan": [
        4567
    ],
    "htang": [
        4567
    ],
    "htangan": [
        4567
    ],
    "huehuetenango mam": [
        4585
    ],
    "huehuetenango": [
        4585
    ],
    "huautla": [
        4594
    ],
    "highland mazatec": [
        4594
    ],
    "huautla mazatec": [
        4594
    ],
    "higaonon": [
        4600
    ],
    "higaonon manobo": [
        4600
    ],
    "higaunon": [
        4600
    ],
    "hinigaunon": [
        4600
    ],
    "hitnü": [
        4612
    ],
    "hagen": [
        4683,
        7900,
        7901,
        7902
    ],
    "hulo": [
        4692,
        4693
    ],
    "hassaniyya": [
        4704,
        4705
    ],
    "hasanya": [
        4704,
        4705
    ],
    "hasaniya": [
        4704,
        4705
    ],
    "hasanya arabic": [
        4704,
        4705
    ],
    "hassani": [
        4704,
        4705
    ],
    "hassania": [
        4704,
        4705
    ],
    "hassaniya": [
        4704,
        4705
    ],
    "hassaniyya arabic": [
        4704,
        4705
    ],
    "hᴐ morokodo": [
        4741
    ],
    "hᴐ": [
        4741
    ],
    "hma’ btsisi’": [
        4771
    ],
    "hma’": [
        4771
    ],
    "hambukushu": [
        4786
    ],
    "highland guerrero mixtec": [
        4804
    ],
    "hagunaax": [
        4810
    ],
    "hayuuc": [
        4810
    ],
    "huajuapan mixtec": [
        4813
    ],
    "huajuapan": [
        4813
    ],
    "holólupai": [
        4820
    ],
    "hainan miao": [
        4824
    ],
    "hill pantaram": [
        4832
    ],
    "hmwaeke": [
        4865
    ],
    "htin": [
        4879,
        4880
    ],
    "ht’in": [
        4879,
        4880
    ],
    "hsianghsi miao": [
        4918,
        5139
    ],
    "hsianghsi": [
        4918,
        5139
    ],
    "huayuan miao": [
        4918
    ],
    "huayuan": [
        4918
    ],
    "halh": [
        4929,
        4931,
        4926,
        4927,
        4932
    ],
    "halha": [
        4926,
        4927,
        4929,
        4931,
        4932
    ],
    "hegeunga": [
        4955
    ],
    "hamakhav": [
        4978
    ],
    "hamakhav chakwar": [
        4978
    ],
    "huhelia": [
        5024
    ],
    "high mari": [
        5049
    ],
    "highland mari": [
        5049
    ],
    "hmwaveke": [
        5050
    ],
    "hill maria": [
        5058
    ],
    "holifoersch": [
        5066
    ],
    "hmong daw": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "hmong dao": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "hmong der": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "hmong dleu": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "hmong qua mpa": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "hmong rongd": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "hmongb dleub": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "hmoob dawb": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "huitepec": [
        5223
    ],
    "huitepec mixtec": [
        5223
    ],
    "huazolotitlán": [
        5224
    ],
    "hai||’om": [
        5300
    ],
    "hungworo": [
        5303
    ],
    "hainman": [
        5318
    ],
    "huasteca": [
        5341,
        5449,
        5464
    ],
    "hidalguense": [
        5341
    ],
    "henkha": [
        5396
    ],
    "hayuuk": [
        5403
    ],
    "hin": [
        5408
    ],
    "hoen": [
        5408
    ],
    "hun": [
        5408
    ],
    "heun": [
        5408
    ],
    "heuny": [
        5408
    ],
    "huasteca nahuatl": [
        5449
    ],
    "hidalgo": [
        5449,
        7413
    ],
    "huaxcaleca": [
        5459
    ],
    "huaxcaleca aztec": [
        5459
    ],
    "huaxcaleca nahuatl": [
        5459
    ],
    "hongalla": [
        5473
    ],
    "hate": [
        5480
    ],
    "hema": [
        5490
    ],
    "hema-sud": [
        5490
    ],
    "hlota": [
        5496
    ],
    "hatigoria": [
        5502
    ],
    "haam": [
        5519,
        5520
    ],
    "hmanggona": [
        5545
    ],
    "hmonono": [
        5545
    ],
    "huku": [
        5549
    ],
    "havakinau": [
        5594
    ],
    "haimi": [
        5701,
        5702,
        5703
    ],
    "hawa": [
        5701,
        5702,
        5703
    ],
    "heimi": [
        5701,
        5702,
        5703
    ],
    "highland nung": [
        5745
    ],
    "hima": [
        5800,
        6566,
        6567,
        6635,
        6636
    ],
    "howe": [
        5867
    ],
    "halung": [
        5891
    ],
    "halungge": [
        5891
    ],
    "havai": [
        5905
    ],
    "hombo": [
        5910
    ],
    "humurana": [
        5916
    ],
    "hunurana": [
        5916
    ],
    "ha-ñeʼokĭ": [
        5937
    ],
    "hantong": [
        5938
    ],
    "heve": [
        5946
    ],
    "haira": [
        5956
    ],
    "hñahñu": [
        5983
    ],
    "huehuetla": [
        7413,
        5987
    ],
    "hñohño": [
        5989
    ],
    "hñatho": [
        5991
    ],
    "huei": [
        6007
    ],
    "haliti": [
        6016
    ],
    "haithe": [
        6075
    ],
    "hatzfeldhafen": [
        6091
    ],
    "hengo": [
        6094
    ],
    "hng": [
        6121
    ],
    "hán": [
        6124
    ],
    "hagahai": [
        6235
    ],
    "huariapano": [
        6236
    ],
    "hualan yao": [
        6244
    ],
    "hualan": [
        6244
    ],
    "highland popoluca": [
        6255
    ],
    "habenapo": [
        6259
    ],
    "h’hana": [
        6259
    ],
    "hinapavosa": [
        6279
    ],
    "hoanya": [
        6279
    ],
    "hand talk": [
        6310
    ],
    "hand": [
        6310
    ],
    "hã-ha-hãe": [
        6342
    ],
    "hã hã hãe": [
        6342
    ],
    "hã": [
        6342
    ],
    "hãe": [
        6342
    ],
    "hok": [
        6365
    ],
    "hpinba": [
        6391
    ],
    "hpyin": [
        6391
    ],
    "huallaga huánuco quechua": [
        6397
    ],
    "huánuco": [
        6418,
        6397,
        6438
    ],
    "huallaguino": [
        6397
    ],
    "huamalíes-dos": [
        6418
    ],
    "huamalíes-dos de mayo huánuco quechua": [
        6418
    ],
    "huanuco": [
        6422
    ],
    "huaylla": [
        6427
    ],
    "huanca huaylla quechua": [
        6427
    ],
    "huanca": [
        6427,
        6448
    ],
    "huaylla wanca quechua": [
        6427
    ],
    "huancayo": [
        6427
    ],
    "huaylas": [
        6432,
        6441
    ],
    "huaylas ancash quechua": [
        6432
    ],
    "huanca jauja quechua": [
        6448
    ],
    "humai": [
        6486
    ],
    "hellenoromani": [
        6507
    ],
    "hungarian-slovak romani": [
        6542
    ],
    "hungarian-slovak": [
        6542
    ],
    "hispanoromani": [
        6558
    ],
    "hambo": [
        6640
    ],
    "humu": [
        6640
    ],
    "har": [
        6676,
        6677,
        6678,
        6679,
        6680
    ],
    "har rar": [
        6676,
        6677,
        6678,
        6679,
        6680
    ],
    "hatue": [
        6681
    ],
    "hambali": [
        6702
    ],
    "himbaka": [
        6714
    ],
    "hyolmo": [
        6732
    ],
    "helambu sherpa": [
        6732
    ],
    "helambu": [
        6732
    ],
    "hyolmo tam": [
        6732
    ],
    "hadang": [
        6777
    ],
    "hdang": [
        6777
    ],
    "hotea": [
        6777
    ],
    "hoteang": [
        6777
    ],
    "hsemtang": [
        6798
    ],
    "hsiao hwa miao": [
        6801
    ],
    "hsiao": [
        6801
    ],
    "hana": [
        6856
    ],
    "ho nte": [
        6859
    ],
    "huo nte": [
        6859
    ],
    "huo": [
        6859
    ],
    "hissala": [
        6877,
        7140
    ],
    "hog harbour": [
        6933
    ],
    "hog": [
        6933
    ],
    "hiyewe": [
        7015
    ],
    "heso": [
        7026
    ],
    "hendo": [
        7028
    ],
    "himachali": [
        7123,
        7124
    ],
    "hla’alua": [
        7262
    ],
    "huari": [
        7328
    ],
    "hwang": [
        7372
    ],
    "hoai petel": [
        7400
    ],
    "hoai": [
        7400
    ],
    "huehuetla tepehua": [
        7413
    ],
    "habashi": [
        7493,
        7494,
        7495
    ],
    "hol": [
        7566,
        7567
    ],
    "haruai": [
        7590
    ],
    "harway": [
        7590
    ],
    "highland totonac": [
        7653
    ],
    "ho muong meridional": [
        7654
    ],
    "hatohobei": [
        7657
    ],
    "hàng tong": [
        7672
    ],
    "hàng": [
        7672
    ],
    "huauchinango": [
        7691
    ],
    "hill tippera": [
        7714,
        7715
    ],
    "hogo": [
        7722
    ],
    "humboldt jotafa": [
        7763
    ],
    "humboldt": [
        9126,
        7763
    ],
    "honya": [
        7791
    ],
    "haat": [
        7863
    ],
    "hat": [
        7863,
        8916
    ],
    "highland tzeltal": [
        7880
    ],
    "huixtan": [
        7889
    ],
    "huamuê": [
        7893
    ],
    "hamung": [
        7927
    ],
    "hoche": [
        7946
    ],
    "hol-chih": [
        7946
    ],
    "heriki": [
        7981,
        7982,
        7983
    ],
    "hoɽo jagar": [
        7981,
        7982,
        7983
    ],
    "hoɽo": [
        7981,
        7982,
        7983
    ],
    "hun-ne": [
        8024
    ],
    "hune": [
        8024
    ],
    "haki piki": [
        8045
    ],
    "haki": [
        8045
    ],
    "hakkipikkaru": [
        8045
    ],
    "huarijío": [
        8058
    ],
    "huarijio": [
        8058
    ],
    "hayu": [
        8064
    ],
    "hhagiree": [
        8181
    ],
    "hom": [
        8186
    ],
    "honitetu": [
        8209
    ],
    "ho-chunk": [
        8239
    ],
    "hocak wazijaci": [
        8239
    ],
    "hocak": [
        8239
    ],
    "hocank": [
        8239
    ],
    "hochank": [
        8239
    ],
    "hochunk": [
        8239
    ],
    "hocák": [
        8239
    ],
    "hocąk": [
        8239
    ],
    "hoocąk": [
        8239
    ],
    "hinzua": [
        8292,
        8293
    ],
    "hanga hundi": [
        8319
    ],
    "hundi": [
        8319
    ],
    "huà": [
        8369,
        8370,
        8371
    ],
    "hilu humba": [
        8424
    ],
    "hilu": [
        8424
    ],
    "hdi": [
        8451
    ],
    "hedi": [
        8451,
        8533
    ],
    "hide": [
        8451
    ],
    "hǝdi": [
        8451
    ],
    "hetá": [
        8458
    ],
    "haura": [
        8459
    ],
    "haura haela": [
        8459
    ],
    "haela": [
        8459
    ],
    "houro": [
        8459
    ],
    "hovoiroro": [
        8459
    ],
    "hovoyo": [
        8459
    ],
    "harami": [
        8474
    ],
    "hunnic": [
        8475
    ],
    "hernican": [
        8478
    ],
    "hattic": [
        8479
    ],
    "hurrian": [
        8480
    ],
    "hottentot": [
        8483
    ],
    "highland kenyah": [
        8502
    ],
    "hedi mbudum": [
        8533
    ],
    "hayahaya": [
        8580
    ],
    "hal kurumba": [
        8669
    ],
    "hal": [
        8669
    ],
    "hukwe": [
        8684
    ],
    "houéda": [
        8693
    ],
    "háusi kúta": [
        8723
    ],
    "háusi": [
        8723
    ],
    "haiao": [
        8733,
        8734
    ],
    "hajao": [
        8733,
        8734
    ],
    "hiao": [
        8733,
        8734
    ],
    "hyao": [
        8733,
        8734
    ],
    "hiak-nooki": [
        8736
    ],
    "hiaki": [
        8736
    ],
    "hodï": [
        8740
    ],
    "hasha": [
        8752
    ],
    "hei muji": [
        8753,
        8887
    ],
    "hobacana": [
        8756
    ],
    "hei yi": [
        8761,
        8949,
        8950
    ],
    "hands in action": [
        8787
    ],
    "hands": [
        8787
    ],
    "hlepho": [
        8792
    ],
    "hlepho phowa": [
        8792
    ],
    "hlaka mujima": [
        8856
    ],
    "hlaka": [
        8856
    ],
    "hua phu": [
        8888
    ],
    "hlagho": [
        8890
    ],
    "hei phu": [
        8891
    ],
    "hrong": [
        8898
    ],
    "hei mao ren": [
        8916
    ],
    "ha xa phang": [
        8923,
        8924,
        8925,
        8926
    ],
    "hai nam": [
        8923,
        8924,
        8925,
        8926
    ],
    "hoa": [
        8923,
        8924,
        8925,
        8926
    ],
    "hong kong cantonese": [
        8923,
        8924,
        8925,
        8926
    ],
    "huong": [
        8923,
        8924,
        8925,
        8926
    ],
    "havasupai-walapai-yavapai": [
        8927
    ],
    "hongshuihe": [
        9004,
        9009
    ],
    "heiyi zhuang": [
        9015
    ],
    "heiyi": [
        9015
    ],
    "hoton": [
        9020,
        9021,
        9022,
        9030,
        9040
    ],
    "hui-zu": [
        9020,
        9021,
        9022,
        9030,
        9040
    ],
    "hytad": [
        9020,
        9021,
        9022,
        9030,
        9040
    ]
};
